import { IHistoryTableRequest } from 'models/feedplan'
import axAPI from '../httpConfig'

const toHistoryRows = (payload: unknown): IHistoryTableRequest[] => {
	if (Array.isArray(payload)) return payload
	if (
		payload &&
		typeof payload === 'object' &&
		Array.isArray((payload as { results?: unknown }).results)
	) {
		return (payload as { results: IHistoryTableRequest[] }).results
	}
	return []
}

export default class PlanApiService {
	static postChangedPlans = async data => {
		return axAPI({
			method: 'POST',
			url: `/feedplans/`,
			data: { plans: data },
		})
	}
	static getFeedplans = async date => {
		return axAPI.get(`feedplans/${date}`)
	}
	static getFeedplansEdit = async date => {
		return axAPI.get(`feedplans/${date}/edit`)
	}
	static getHistoryChangedForAllGroups = async (
		endDate: string,
	): Promise<IHistoryTableRequest[]> => {
		try {
			const response = await axAPI.get(`/feedplan/history/${endDate}`, {
				params: { page_size: 100 },
			})
			return toHistoryRows(response.data)
		} catch (error) {
			console.error(error)
			throw error
		}
	}
	static getHistoryChangedByGroupkey = async (
		endDate: string,
		groupkey: string,
	): Promise<IHistoryTableRequest[]> => {
		try {
			const response = await axAPI.get(
				`/feedplan/history/${endDate}/${groupkey}`,
				{ params: { page_size: 100 } },
			)
			return toHistoryRows(response.data)
		} catch (error) {
			console.error(error)
			throw error
		}
	}
}
